module.exports = __webpack_public_path__ + "img/aierlogo_icon.12f2e280.png";